<script lang="ts" setup>
import type { DetailsHeadingVariant } from '@autobid/ui/types/components/CarDetails'
import { useAutoAnimate } from '@formkit/auto-animate/vue'

interface Props {
  variant?: DetailsHeadingVariant
  headingClass?: string
  contentClass?: string
}

defineProps<Props>()

const active = ref(true)

const [parent] = useAutoAnimate({ easing: 'linear' })
</script>

<template>
  <div class="text-sm text-[#58585A] md:text-[15px]">
    <div class="mb-2 flex items-center">
      <SectionsDetailsElementsHeading
        :class="`w-full ${headingClass ?? ''}`"
        :variant="variant"
      >
        <div class="flex items-center justify-between">
          <slot name="heading" />

          <button
            type="button"
            :class="{ 'md:hidden': active }"
            @click="active = !active"
          >
            <Icon
              mode="svg"
              class="-my-2 h-6 w-6 text-5xl transition-transform duration-300"
              name="fa-solid:chevron-down"
              :class="active ? 'rotate-180' : ''"
            />
          </button>
        </div>
      </SectionsDetailsElementsHeading>
      <slot name="after-heading" />
    </div>

    <div ref="parent">
      <div v-if="active" :class="`w-full px-2.5 md:px-4 ${contentClass ?? ''}`">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>
